export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}licence/licence-drl/:id`;
    return $resource(url, null, {
        set: {
            method: 'POST',
            url: `${url}/set`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/LicenceDrl/index.js